import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { BALANCE_API } from "./constants";
import queryKeys from "./queryKeys";

export interface Balance {
  currencyCode: string;
  settleBalance: number;
  tradeBalance: number;
  unsettledBalance: number;
}

export interface BalancesResponse {
  [type: string]: Balance[];
}

export function useGetBalances(account: string, processDate?: string) {
  const apiURL = `${getAppConfigSetting("apiUrl")}${BALANCE_API}`;

  const fetchMargins = async () => {
    const { data } = await axios.get<BalancesResponse>(
      `${apiURL}/${account}${processDate ? `?processDate=${processDate}` : ""}`,
      {
        withCredentials: true,
      }
    );
    return data;
  };

  return useQuery<BalancesResponse, AxiosError>(
    [queryKeys.getMargins, account, processDate],
    fetchMargins,
    {
      enabled: !!account,
    }
  );
}
